var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row marketing" }, [
      _c("div", { staticClass: "col-3" }, [
        _c("h4", { staticClass: "form-head" }, [
          _vm._v("\n          Config\n        ")
        ]),
        _vm._v(" "),
        _c("form", { attrs: { name: "pform" } }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "opin" } }, [
              _vm._v("Common Alert EMails")
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.tenant.alertEMails,
                  expression: "tenant.alertEMails"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "opin", placeholder: "Enter EMails One Per Line" },
              domProps: { value: _vm.tenant.alertEMails },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.tenant, "alertEMails", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary mt-3",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.saveAlertEMail()
                }
              }
            },
            [
              _c("i", { staticClass: "fa fa-save" }),
              _vm._v(" Save\n          ")
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02aee9c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02aee9c1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/EwbConfigPage.vue
// module id = null
// module chunks = 